import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'react-query/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import App from './App';
import RTL from './utils/RTL';
import { PatientsProvider } from './store/context/patient-context';
import { AuthContextProvider } from './store/context/auth/auth-context';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1200,
      xl: 1536
    }
  },
  typography: {
    fontFamily: ['dana', 'dana-bold'].join(',')
  },
  palette: {
    primary: {
      main: '#753cbe'
    },
    secondary: {
      main: '#1fb9ee'
    }
  },
  direction: 'rtl'
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <AuthContextProvider>
        <PatientsProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <RTL>
                <App />
              </RTL>
            </ThemeProvider>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </PatientsProvider>
      </AuthContextProvider>
    </Router>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    // Unregister all registered service workers
    registrations.forEach(function (registration) {
      registration.unregister();
    });
  });
}

if ('caches' in window) {
  caches.keys().then(function(cacheNames) {
    cacheNames.forEach(function(cacheName) {
      caches.delete(cacheName);
    });
  });
}
